import {
  ChangeDetectionStrategy,
  Component,
  Input,
  ViewContainerRef,
} from '@angular/core';
import { PageScrollingService } from '@shared/services/page-scrolling';

/**
 * Родительский элемент должен быть "position: relative;" и плавающая кнопка должна быть первым элементом в нем.
 * Тогда она будет изначально выровнена по правому верхнему краю родительского элемента и не сможет выходить за его границы.
 */
@Component({
  selector: 'app-floating-button',
  templateUrl: './floating-button.component.html',
  styleUrls: ['./floating-button.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FloatingButtonComponent {
  constructor(
    private container: ViewContainerRef,
    private pageScrolling: PageScrollingService
  ) {}

  @Input() cmpModal: unknown | undefined;
  @Input() isActiveFilter = false;

  openModal(): void {
    this.pageScrolling.togglePageScroll();
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const modal = this.container.createComponent(this.cmpModal);
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    modal.instance.container = this.container;
  }
}
